import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { listUruPasses } from "@/lib/api";

// URU Games passes (routes/uru_pass.py): how many were issued and claimed, and who claimed which gym.
export default function UruPasses() {
  const [d, setD] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { listUruPasses().then(setD).catch((e) => setError(e?.response?.data?.detail || "Couldn't load.")); }, []);
  if (error) return <div className="p-6 text-red-400">{error}</div>;
  if (!d) return <Loader2 className="m-6 h-5 w-5 animate-spin" />;
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">URU Games passes</h1>
      <p className="mt-1 text-sm opacity-70">{d.counts.claimed} claimed of {d.counts.issued} issued</p>
      <div className="mt-4 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left opacity-70">
            <th className="py-2 pr-4">Name</th><th className="pr-4">Phone</th><th className="pr-4">Gym</th>
            <th className="pr-4">Starts</th><th className="pr-4">Ends</th><th className="pr-4">Passed on</th><th>GHL</th>
          </tr></thead>
          <tbody>{d.claimed.map((r) => (
            <tr key={r.code} className="border-t border-white/10">
              <td className="py-2 pr-4">{r.name}</td><td className="pr-4">{r.phone}</td><td className="pr-4">{r.gym}</td>
              <td className="pr-4">{r.start_date}</td><td className="pr-4">{r.end_date}</td>
              <td className="pr-4">{r.passed_on ? `Yes (from ${r.holder})` : "No"}</td><td>{r.ghl || ""}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
